import { Benefits } from './Benefits'
import { OfferNote } from './OfferNote'
import css from '../style.module.scss'

export const Sidebar = function Sidebar() {
  return (
    <div className={css['show-for-tablet']}>
      <OfferNote />
      <Benefits />
    </div>
  )
}
